import { useState } from "react";
import ReactQuill from "react-quill"; // NEW: Import rich text engine
import "react-quill/dist/quill.snow.css"; // NEW: Import clean editor theme styles
import FuelLoading from "../../pages/FuelLoading";
import "./blogAdmin.scss";
import { useCreateBlogPostMutation } from "../../features/api/blogApiSlice";

// NEW: Configure custom scannable toolbar actions for your travel journal posts
const quillModules = {
  toolbar: [
    [{ header: [2, 3, false] }],
    ["bold", "italic", "underline", "blockquote"],
    [{ list: "ordered" }, { list: "bullet" }],
    ["link", "clean"],
  ],
};

export default function AdminBlogCreate() {
  const [title, setTitle] = useState("");
  const [category, setCategory] = useState("Road Trips");
  const [excerpt, setExcerpt] = useState("");
  const [content, setContent] = useState(""); // Stores HTML markup string logic
  const [isPublished, setIsPublished] = useState(false);

  const [selectedFile, setSelectedFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const [createBlogPost, { isLoading: isSubmitting }] =
    useCreateBlogPostMutation();

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setSelectedFile(file);
    setPreviewUrl(URL.createObjectURL(file));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess(false);

    // Basic length verification check on HTML string streams
    if (
      !title.trim() ||
      !excerpt.trim() ||
      !content.trim() ||
      content === "<p><br></p>"
    ) {
      setError("Please fill out all required text parameters.");
      return;
    }

    const formData = new FormData();
    formData.append("title", title.trim());
    formData.append("category", category);
    formData.append("excerpt", excerpt.trim());
    formData.append("content", content.trim()); // Sends rich HTML payload string down the wire
    formData.append("isPublished", String(isPublished));

    if (selectedFile) {
      formData.append("coverImage", selectedFile);
    }

    try {
      await createBlogPost(formData).unwrap();
      setSuccess(true);
      setTitle("");
      setExcerpt("");
      setContent(""); // Reset rich text canvas block
      setSelectedFile(null);
      setPreviewUrl("");
    } catch (err) {
      setError(
        err?.data?.message || "Failed to publish blog post down the road."
      );
    }
  };

  if (isSubmitting) {
    return (
      <div className="admin-blog-loading">
        <FuelLoading text="Streaming asset bytes directly to AWS cloud layers..." />
      </div>
    );
  }

  return (
    <div className="admin-blog-wrapper fuel-fade-in">
      <div className="admin-blog-header">
        <h2>Compose New Journal Entry</h2>
        <p>
          Write content logs and push binary assets straight up to S3 bucket
          containers.
        </p>
      </div>

      <form className="blog-form-card" onSubmit={handleSubmit}>
        {success && (
          <div className="blog-admin-success">
            🎉 Article entry successfully added to database charts!
          </div>
        )}
        {error && <div className="blog-admin-error">⚠️ {error}</div>}

        <div className="blog-form-grid">
          <div className="form-text-inputs">
            <label>
              Post Title *
              <input
                type="text"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                placeholder="e.g. Navigating the Black Hills"
              />
            </label>

            <div className="form-row-split">
              <label>
                Category Tag
                <select
                  value={category}
                  onChange={(e) => setCategory(e.target.value)}
                >
                  <option value="Road Trips">🗺️ Road Trips</option>
                  <option value="National Parks">🏞️ National Parks</option>
                  <option value="Gear Reviews">⚙️ Gear Reviews</option>
                  <option value="Small Car Life">🚗 Small Car Life</option>
                </select>
              </label>

              <label className="checkbox-label">
                <input
                  type="checkbox"
                  checked={isPublished}
                  onChange={(e) => setIsPublished(e.target.checked)}
                />
                Publish immediately to public feeds
              </label>
            </div>

            <label>
              Short Excerpt Summary * (Appears on grid previews)
              <input
                type="text"
                value={excerpt}
                onChange={(e) => setExcerpt(e.target.value)}
                placeholder="A brief one-sentence hook for the article feed lists..."
              />
            </label>

            {/* FIXED: Swapped raw input element textarea out for ReactQuill component */}
            <div className="quill-wrapper-box">
              <span className="field-label-text">Article Body Content *</span>
              <ReactQuill
                theme="snow"
                value={content}
                onChange={setContent}
                modules={quillModules}
                placeholder="Start writing your road story here..."
              />
            </div>
          </div>

          <div className="form-image-handler">
            <span className="section-label-tag">Cover Photo Asset</span>
            <div className="image-uploader-box">
              {previewUrl ? (
                <div className="image-preview-frame">
                  <img
                    src={previewUrl}
                    alt="Upload testing preview indicator"
                  />
                  <button
                    type="button"
                    className="clear-img-btn"
                    onClick={() => {
                      setSelectedFile(null);
                      setPreviewUrl("");
                    }}
                  >
                    Change Photo ✕
                  </button>
                </div>
              ) : (
                <div className="empty-upload-slate">
                  <span className="icon">📷</span>
                  <p>
                    Drop file or click below to append high-fidelity cover
                    assets.
                  </p>
                  <input
                    type="file"
                    accept="image/*"
                    id="blog-file-upload"
                    onChange={handleFileChange}
                  />
                  <label
                    htmlFor="blog-file-upload"
                    className="file-trigger-btn"
                  >
                    Choose File Image
                  </label>
                </div>
              )}
            </div>
          </div>
        </div>

        <button type="submit" className="fuel-primary-btn publish-log-btn">
          🚀 Commit & Upload Journal Entry
        </button>
      </form>
    </div>
  );
}
